import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { AccessLevels } from 'src/app/models/access_levels';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { WarningConfirmModalComponent } from '../modal-pop-ups/warning-confirm-modal/warning-confirm-modal.component';
import { BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  host: { 'class': 'w-100 d-flex align-items-center' }
})
export class LoginComponent implements OnInit {

  login_form: FormGroup;
  submitted = false;
  hide = false;
  isLogin = false;

  constructor(private notifier: NotifierService,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private router: Router,
    private spinnerService: NgxSpinnerService) {
    this.notifier = notifier;
  }

  ngOnInit() {
    this.login_form = this.formBuilder.group({
      username: new FormControl('', Validators.compose([
        Validators.required,
        Validators.email
      ])),
      password: new FormControl('', Validators.compose([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(15),
        // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$')
        // Validators.pattern('^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$]).*$')
      ])),
    });
  }

  get f() {
    return this.login_form.controls
  }

  onSubmit() {
    this.submitted = true;
    this.login_form.markAllAsTouched()
    if (this.login_form.invalid) {
      if (this.login_form.get('username').value=="" && this.login_form.get('password').value=="" || this.login_form.get('username').invalid && this.login_form.get('password').invalid){
        this.notifier.notify('warning','Please enter valid username and password')
      }
      if (this.login_form.get('username').valid && this.login_form.get('password').invalid){
        this.notifier.notify('warning','Please enter valid password')
      }

      if (this.login_form.get('username').invalid && this.login_form.get('password').valid){
        this.notifier.notify('warning','Please enter valid username')
      }
      return;
    }
    
    this.isLogin = true
    this.spinnerService.show()
    this.authenticationService.login(this.login_form.controls.username.value, this.login_form.controls.password.value).subscribe((res) => {
      this.spinnerService.hide()
      this.isLogin = false
      if (res['status'] == true) {
        if (this.authenticationService.getAccessLevel() === AccessLevels.superAdmin || this.authenticationService.getAccessLevel() === AccessLevels.stationManager) {
          this.router.navigateByUrl('/home');
          if (res['result']['isFirstLogin']) {
            const initialState = {
              title: "Please change your password!"
            };
            const modalRef = this.modalService.show(WarningConfirmModalComponent, { initialState });
            modalRef.setClass('modal-lg modal-dialog-centered modal-dialog-scrollable');
            modalRef.content.event.subscribe(res => {
              if (res.data) {
                // this.services.splice(index, 1);
              } else {
                modalRef.hide()
              }
            })
            // this.notifier.notify('warning', 'Please change your password!')
          }
        } else {
          this.notifier.notify('warning', 'Permissions denied!')
          this.router.navigateByUrl('/login');
        }
      } else {
        this.notifier.notify('danger', res['message'])
      }
    });
  }


  public showAlert(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

  validation_messages = {
    'username': [
      { type: 'required', message: 'Email required.' },
      { type: 'email', message: 'Email format must be similar to joe@abc.com' },
    ],
    'password': [
      { type: 'required', message: 'Password required.' },
      { type: 'minlength', message: 'Password must be at least 6 characters long.' },
      { type: 'maxlength', message: 'Password length cannot exceed 15 characters.' },
      { type: 'pattern', message: 'Password must contain at least one uppercase, one lowercase, one number and one special character($,@,#)' }
    ],
  }

  myFunction() {
    this.hide = !this.hide;
  }


}
